import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import { findArea, findWorkflow } from '@/utils/generalFunctions';

export default {
  data() {
    return {
      hidden: false,
      step_percentage: 0,
      step_loading_txt: "",
      loadingAllDataRequired: false,
      contract: null,
      inventory: null,
      area: null,
      fatherArea: null,
      workflows: {
        salud: null,
        seguridad: null,
        medioambiente: null,
      },
      contractPeople: [],
    };
  },
  computed: {
    ...mapGetters({
      usersFaena: 'usersFaena',
    }),
  },
  async created() {
    this.loadingAllDataRequired = true;
    try {
      this.resetInventory();
      // Obtener Contrato
      this.step_percentage = 0;
      this.step_loading_txt = "Cargando contrato";
      await this.getContract(this.$route.params.contratoId);
      this.step_percentage = 20;
      // Obtener inventario
      // Obtener áreas
      if (this.$store.getters.areas.length === 0) {
        this.step_percentage = 40;
        this.step_loading_txt = "Obteniendo áreas";
        // no hay store de areas
        this.getContractArea(this.contract.area_id);
        if (this.area && this.area.area_padre_id) {
          this.step_percentage = 50;
          this.step_loading_txt = "Configurando áreas";
          this.getContractFatherArea(this.area.area_padre_id);
        } // if
      } else {
        this.step_percentage = 60;
        this.step_loading_txt = "Configurando áreas";
        this.area = findArea(this.contract.area_id);
        this.fatherArea = findArea(this.area.area_padre_id);
      } // if

      // Obtener Workflows
      const cwf = this.contract.workflows;
      if (this.$store.getters.workflows.length === 0) {
        this.step_percentage = 70;
        this.step_loading_txt = "Obteniendo flujos de revisión";
        // no hay store de Workflows
        await this.getWorkflowByType('salud', cwf.salud);
        await this.getWorkflowByType('seguridad', cwf.seguridad);
        await this.getWorkflowByType('medioambiente', cwf.medioambiente);
      } else {
        this.step_percentage = 80;
        this.step_loading_txt = "Configurando flujos de revisión";
        this.workflows.salud = findWorkflow(cwf.salud);
        this.workflows.seguridad = findWorkflow(cwf.seguridad);
        this.workflows.medioambiente = findWorkflow(cwf.medioambiente);
      } // if
      this.step_percentage = 90;
      this.step_loading_txt = "Obteniendo usuarios del contrato";
      // Obtener personas del contrato
      if (this.usersFaena.length === 0) {
        await this.getUsersFaena(this.$store.getters.role.faena_id);
      }
      this.contractPeople = this.usersFaena;
      this.step_loading_txt = "Obteniendo inventario";
      await this.getInventory();
      this.step_percentage = 100;
      this.step_loading_txt = "Carga completa del Inventario realizada";
      this.loadingAllDataRequired = false;
    } catch {
      this.loadingAllDataRequired = false;
      console.log('Error al cargar los datos');
    }
  },
  methods: {
    ...mapActions([
      'getUsersFaena',
      'resetInventory',
    ]),
    async getContract(id) {
      const self = this;
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      };
      await axios.get(`contratos/${id}`, config)
        .then((response) => {
          self.contract = response.data;
          // Para los componentes :/
          self.$store.dispatch('setActualContract', response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getInventory() {
      this.loading = true;
      const self = this;
      await this.$store
        .dispatch('getInventory', this.contract)
        .then(() => {
          self.inventory = self.$store.getters.inventario;
          self.loading = false;
        });
    },
    async getContractArea(id) {
      this.area = await this.getArea(id);
    },
    async getContractFatherArea(id) {
      this.fatherArea = await this.getArea(id);
    },
    async getArea(id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
      const response = await axios.get(`areas/${id}`, config);
      return response.data;
    },
    async getWorkflowByType(type, id) {
      this.workflows[type] = await this.getWorkflow(id);
    },
    async getWorkflow(id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
      const response = await axios.get(`workflow/${id}`, config);
      return response.data;
    },
  },
};
